import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import ProductPrice from '@components/Product/Price';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ProductVariation } from '@typings/product';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';
import Product from '@models/product';
import { useIsMobile } from '@repo/ui/src/utils/useMediaQuery';

interface Props {
  variation: ProductVariation | Product;
}

const isProductVariation = (item: ProductVariation | Product): item is ProductVariation =>
  !!(item as ProductVariation).attributesMap;

const GrillCardInterior = ({ variation }: Props) => {
  const { t } = useTranslation();

  const isMobile = useIsMobile();

  const cookingSpace = isProductVariation(variation)
    ? variation?.grillSize
    : variation?.productData?.cookingSpace?.tier?.reduce(
        (total, tier) => tier.width * tier.depth + total,
        0,
      ) || null;

  const imgUrl = buildImageSrc(undefined, 98, 1, 1, variation.mainImageUrl);

  return (
    <div className="tw-grid tw-grid-cols-[auto_1fr] tw-justify-center tw-gap-4 sm:tw-gap-5 tw-h-full tw-items-start md:tw-items-center tw-p-5">
      <div className="tw-grid tw-items-center tw-h-full">
        <LazyLoadImage imgComponent={<img src={imgUrl} alt="" />} />
      </div>
      <div className="tw-grid tw-grid-cols-[1fr_auto] sm:tw-gap-5 tw-justify-center tw-items-center tw-h-full">
        <div className="tw-self-center">
          <h3 className="tra-text-web-heading-6 !tw-text-3xl">{variation.title}</h3>
          {cookingSpace && (
            <p className="tra-text-web-body-l tw-pt-2">
              {`${cookingSpace} ${t('productDetailPageContent.cookingAreaText', undefined, {
                default: 'cooking area',
              })}`}
            </p>
          )}
          {isMobile && (
            <ProductPrice
              className="tw-pt-2 !tw-text-2xl"
              product={variation}
              variant="h7"
              component="p"
              align="left"
            />
          )}
          {!variation.isOrderable && variation.ctaButtonType !== 'shopLocal' && (
            <div
              className={classNames(
                'tw-flex tw-items-center tw-justify-center tw-px-6 tw-py-2 tw-mt-2 tw-relative tw-bg-neutral-300 tw-max-w-[130px]',
              )}
            >
              <h6
                className={classNames(
                  'tra-text-web-heading tw-text-sm sm:tw-text-lg tw-text-white tw-mb-0 tw-self-center',
                  'sm:tw-text-sm',
                )}
              >
                {t('productDetailPageContent.outOfStockText', undefined, {
                  default: 'Out of stock',
                })}
              </h6>
            </div>
          )}
        </div>
        {!isMobile && (
          <ProductPrice
            className="sm:tw-items-center tw-pt-2 md:tw-pt-0 sm:tw-flex-col sm:tw-justify-around [&_del]:lg:tw-pt-0 !tw-text-2xl"
            product={variation}
            variant="h7"
            component="p"
            align="left"
          />
        )}
      </div>
    </div>
  );
};

export default GrillCardInterior;
